import { createServerFn } from '@tanstack/react-start';
import { deleteCookie } from '@tanstack/react-start/server';

export const logout = createServerFn({ method: 'POST' }).handler(async () => {
  deleteCookie('authToken', { path: '/' });
  deleteCookie('authToken', { path: '/', sameSite: 'lax' });
  deleteCookie('authToken', { path: '/', sameSite: 'none', secure: true });

  return;
});
